import Video from "../../../../src/gatsby-theme-ggt-material-ui-blog/Video";
import * as React from 'react';
export default {
  Video,
  React
};